module.exports = __webpack_public_path__ + "static/media/speedyg-banner.d765de56.jpg";